module.exports = __webpack_public_path__ + "static/media/Ether Window.8153efad.png";